import React from 'react';
import Background from './components/background';

const App = () => (
  <>
    <Background />
  </>
);

export default App;
